import { UserRole } from '../../../types/manageUsers';
import { Sprint } from '../../../services/organization';

export interface Resource {
  id: number;
  name: string;
  email: string;
  skills: string[];
  skills_name: string[];
  busy: boolean;
  tasks: any[];
  image_url: string;
  cost_per_hour: number;
  billing_per_hour: number;
  invite_status: string;
  teams: { id: number; name: string; }[];
  imported?: boolean;
  is_deleted?: boolean;
  user_role?: UserRole;
}

export enum TabType {
  PEOPLE = 'people',
  TEAMS = 'teams'
}

export enum ViewType {
  CAPACITY = 'capacity',
  PEOPLE_TEAMS = 'people-teams'
}

export enum SearchMode {
  NAME = 'name',
  SKILLS = 'skills',
  TEAM = 'team'
}

export interface TeamFilterState {
  team_id: string;
  team_uuid: string;
  team_name: string;
  team_project: string;
  team_project_name: string;
  area_path: string;
  current_sprint: Sprint | null;
  sprint_mode: boolean;
  sorted_sprints: Sprint[];
  current_sprint_index: number;
  // Optional fields for persistence - store sprint dates when sprint is found
  sprint_start_date?: string | null;
  sprint_end_date?: string | null;
} 